export default "__VITE_ASSET__gDPBSrRYHA$UAxLGdPqngg__"